export const SITE = {
  name: "Bali Empower",
  legalName: "Bali Empower Mental Health Clinic",
  url: "https://baliempower.com",
  phone: "087777430348",
  phoneIntl: "+6287777430348",
  whatsapp: "6287777430348",
  address: {
    street: "Apotik Indobat, Lantai 2, Jl. Tukad Yeh Aya No. 100",
    area: "Renon",
    city: "Denpasar Selatan",
    region: "Bali",
    postal: "80234",
    country: "Indonesia",
  },
  mapsUrl: "https://maps.app.goo.gl/jzP8zDYxZFNvcrHL9",
  mapsEmbed:
    "https://www.google.com/maps?q=Jl.+Tukad+Yeh+Aya+No.+100,+Renon,+Denpasar+Selatan,+Bali+80234&output=embed",
};

export const waLink = (text) =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(text)}`;

export const WHATSFORM_URL = "https://whatsform.com/7YnllB";

export const HOURS = {
  id: "Senin–Jumat 10.00–22.00 · Sabtu & Minggu 12.00–22.00",
  en: "Monday–Friday 10:00–22:00 · Saturday & Sunday 12:00–22:00",
};

export const PLACEHOLDER = {
  id: "[Informasi akan dilengkapi oleh tim Bali Empower]",
  en: "[Information to be confirmed by the Bali Empower team]",
};

export const IMAGES = {
  hero: "https://images.pexels.com/photos/33709939/pexels-photo-33709939.jpeg?auto=compress&cs=tinysrgb&w=1600",
  clinic: "https://images.unsplash.com/photo-1613553474179-e1eda3ea5734?auto=format&fit=crop&w=1200&q=70",
  room: "https://images.pexels.com/photos/7789602/pexels-photo-7789602.jpeg?auto=compress&cs=tinysrgb&w=1200",
  session: "https://images.pexels.com/photos/14797780/pexels-photo-14797780.jpeg?auto=compress&cs=tinysrgb&w=1200",
  assessment: "https://images.pexels.com/photos/33350433/pexels-photo-33350433.jpeg?auto=compress&cs=tinysrgb&w=1200",
  nature: "https://images.pexels.com/photos/30289289/pexels-photo-30289289.jpeg?auto=compress&cs=tinysrgb&w=1200",
};

export const ORG_JSONLD = {
  "@context": "https://schema.org",
  "@type": ["Organization", "MedicalBusiness"],
  "@id": "https://baliempower.com/#organization",
  name: "Bali Empower",
  alternateName: ["Bali Empower Mental Health Clinic", "Klinik Psikologi Titut Esti | Bali Empower"],
  url: "https://baliempower.com",
  telephone: "+6287777430348",
  openingHoursSpecification: [
    { "@type": "OpeningHoursSpecification", dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"], opens: "10:00", closes: "22:00" },
    { "@type": "OpeningHoursSpecification", dayOfWeek: ["Saturday", "Sunday"], opens: "12:00", closes: "22:00" },
  ],
  address: {
    "@type": "PostalAddress",
    streetAddress: "Apotik Indobat, Lantai 2, Jl. Tukad Yeh Aya No. 100, Renon",
    addressLocality: "Denpasar Selatan",
    addressRegion: "Bali",
    postalCode: "80234",
    addressCountry: "ID",
  },
  areaServed: ["Denpasar", "Bali", "Indonesia"],
  medicalSpecialty: "Psychiatric",
  description:
    "Bali Empower is a psychology and mental health clinic located in Renon, Denpasar Selatan, Bali, providing psychological counseling, psychological assessment and structured mental health programs.",
};
